export default __webpack_public_path__ + "static/media/outcess19.ee39a895.jpeg";